import { RouterUtil } from 'kuaidong-lib'
import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum, VacationHomeworkType } from 'kuaidong-model'

const List = () => import('../views/VacationHomeworkPlanList.vue')
const Edit = () => import('../views/VacationHomeworkPlanEdit.vue')
const Details = () => import('../views/VacationHomeworkPlanDetails.vue')
const EditChooseTemplate = () => import('../views/VacationHomeworkPlanEditChooseTemplate.vue')

export const listRoute: RouteConfig = {
  path: 'plan-list',
  name: 'vacation_homework_plan_list',
  component: List,
  meta: {
    title: '寒假作业',
    showMenu: false,
  },
}

export const editRoute: RouteConfig = {
  path: 'plan-edit',
  name: 'vacation_homework_plan_edit',
  component: Edit,
  meta: {
    title: '寒假作业',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const detailsRoute: RouteConfig = {
  path: 'plan-details',
  name: 'vacation_homework_plan_details',
  component: Details,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '寒假作业',
    [GlobalConfigRouteMetaEnum.All]: true,
    [GlobalConfigRouteMetaEnum.CompetitionType]: true,
  },
}

export const editChooseTemplateRoute: RouteConfig = {
  path: 'plan-edit-choose-template',
  name: 'vacation_homework_plan_edit_choose_template',
  component: EditChooseTemplate,
  meta: {
    title: '寒假作业',
  },
}

export const routes = [listRoute, editRoute, detailsRoute, editChooseTemplateRoute].map((route) => ({
  ...route,
  path: `/vacation-homework/${route.path}`,
}))

export const springSemester2022Routes = RouterUtil.cloneRoutes(
  [listRoute, editRoute, detailsRoute, editChooseTemplateRoute],
  'spring2022',
  '新学期作业',
  {
    type: VacationHomeworkType.SpringSemester2022Homework,
  }
).map((route) => ({
  ...route,
  path: `/spring2022-vacation-homework/${route.path}`,
}))

export function navigateToVacationHomeworkPlanEdit(router: VueRouter) {
  router.push({ path: editRoute.path })
}

export function redirectToVacationHomeworkPlanEdit(router: VueRouter) {
  router.replace({ path: editRoute.path })
}

export function navigateToVacationHomeworkPlanDetails(router: VueRouter, id: string) {
  router.push({ path: detailsRoute.path, query: { id } })
}

export function redirectToVacationHomeworkPlanDetails(router: VueRouter, id: string) {
  router.replace({ path: detailsRoute.path, query: { id } })
}

export function navigateToVacationHomeworkPlanEditChooseTemplate(router: VueRouter) {
  router.push({ path: editChooseTemplateRoute.path })
}
